import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const ContextService = {
    async add(form,id,htmlContent) {
        try {
            const result = await axios.post(`${apiUrl}/context/saveContext/`,
                {
                    "tdr_mission": id,
                    "description_context": htmlContent,
                });
            if (result) {
                // TODO: replace result.data.message by the token
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
    async getId(id) {
        try {
            const result = await axios.get(`${apiUrl}/context/getDetailsById/`+id);
            
            if (result) {
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    }
}
export default ContextService;
